import './langmap';
import './numbers';
import './slider';
import './countries';
import '../../node_modules/slick-carousel/slick/slick'
import './piechart';
import './referenzen';

$(document).ready(function () {

    $('.toggler').on('click', function() {
        $(this).add('#header').toggleClass('active')
    })

    setHeadingsMargin()
    $( window ).on( "resize", function() {
      setHeadingsMargin()
    } );

    function setHeadingsMargin() {
      let sectionOffsetEl = $('.indy-block-section .offset-2');
      sectionOffsetEl.each(function() {
        let sectionEl = $(this)
        let marginLeft = sectionEl.css('marginLeft');
        let columnsBlocks = sectionEl.find('.indy-block-columns');
        columnsBlocks.each(function() {
          $(this).find('.wp-block-heading').first().css('marginLeft','-'+marginLeft)
        })
      })
    }

	// Scroll offset functionality
	$(".nav-wrapper .main .nav-link").on("click", function (event) {
		event.preventDefault();

		let targetId = $(this).attr("href");
		let targetElement = $(targetId);

		// adjust this, to change the offset to the headings
		let offset = 90;

		if (targetElement.length) {
			$("html, body").animate(
				{
					scrollTop: targetElement.offset().top - offset
				},
				100
			);

			// close navigation after click on link element
			$(".nav-wrapper").removeClass('active');
			$("#header").removeClass('active');
		}
	});

	let initialWidth = window.innerWidth;
	let reloadThreshold = 100; // Anzahl Pixel, bei denen ein Reload ausgelöst werden soll
	let hasReloaded = false;

	window.addEventListener("resize", () => {
		let currentWidth = window.innerWidth;

		if (!hasReloaded && initialWidth - currentWidth >= reloadThreshold) {
			hasReloaded = true;
			location.reload();
		}

		if (!hasReloaded && currentWidth - initialWidth >= reloadThreshold) {
			hasReloaded = true;
			location.reload();
		}
	});

});



